export const localPanelSplitterId: unique symbol = Symbol('LocalPanel PanelSplitter');
